import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconContract = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M16.167 4H8a2 2 0 0 0-2 2v10h2.5a1 1 0 1 1 0 2H4a2 2 0 0 0 2 2h2a1 1 0 1 1 0 2H6a4 4 0 0 1-4-4v-1a1 1 0 0 1 1-1h1V6a4 4 0 0 1 4-4h11c.493 0 1.211.14 1.834.588C21.51 3.074 22 3.874 22 5s-.491 1.926-1.166 2.412A3.23 3.23 0 0 1 19 8h-1v.5a1 1 0 1 1-2 0V5c0-.28.045-.633.166-1M18 6h1c.173 0 .456-.06.666-.212.159-.114.334-.314.334-.788s-.175-.674-.334-.788A1.24 1.24 0 0 0 19 4c-.474 0-.674.175-.788.334-.152.21-.212.493-.212.666zM8 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m11.905 1.995a1.1 1.1 0 0 0-.778.322L13 19.416V21h1.584l6.097-6.125.002-.002a1.1 1.1 0 0 0-.778-1.878m-2.19-1.093a3.1 3.1 0 0 1 4.383 4.384v.001l-6.39 6.419A1 1 0 0 1 15 23h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 .295-.709l6.418-6.388z"
            clipRule="evenodd"
        />
    </svg>
);
